<template>
  <div
    :class="[
      ns.b(),
      { [ns.m('border')]: border, [ns.m('tree-line')]: showTreeLine },
      { [ns.is('auto-height')]: autoHeightMode },
      { [ns.is('fill')]: fillMode },
      gridSizeClass,
    ]"
  >
    <grid-tree-toolbar v-if="showToolbar" />
    <div :class="ns.e('main')">
      <div :class="ns.e('body-row')">
        <div :class="ns.e('body-main')">
          <grid-tree-body />
          <grid-tree-loading
            :visible="reactData.loading || reactData.loadError"
            :loading="reactData.loading"
            :error="reactData.loadError"
            :error-message="reactData.loadErrorMsg"
          />
        </div>
      </div>
    </div>
    <div v-if="showPagination" :class="ns.e('pagination')">
      <z-pagination
        v-model:current-page="reactData.currentPage"
        v-model:page-size="reactData.pageSize"
        :page-sizes="reactData.pageSizes"
        :total="reactData.total"
        :size="gridSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        @current-change="onPageChange"
        @size-change="onPageChange"
      />
    </div>
    <grid-context-menu v-if="reactData.initStore.contextMenu" />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, nextTick } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import ZPagination from '@zoryn/components/pagination'
import GridTreeToolbar from './grid-tree-toolbar.vue'
import GridTreeBody from './grid-tree-body.vue'
import GridTreeLoading from './grid-tree-loading.vue'
import GridContextMenu from '@zoryn/components/grid/src/components/grid-context-menu.vue'
import { resolveTreeConfig } from '../tree/tree-config'
import { applyClientPagination } from '../tree/sync-table-data'
import type { DataGridTree } from '../types'

const ns = useNamespace('grid')
const $grid = inject('$grid') as DataGridTree
const { reactData, props } = $grid

const border = computed(() => props.border !== false)
const showTreeLine = computed(() => resolveTreeConfig($grid.options).showLine)
const showToolbar = computed(() => $grid.options.toolbar !== false)
const showPagination = computed(() => $grid.options.pagination !== false)
const gridSize = computed(() => $grid.gridSize.value)
const gridSizeClass = computed(() => {
  const size = gridSize.value
  return size && size !== 'default' ? ns.m(size) : ''
})
const autoHeightMode = computed(
  () =>
    props.autoHeight !== false
    && (props.height == null || props.height === '')
)
const fillMode = computed(
  () =>
    props.autoHeight === false
    && (props.height == null || props.height === '')
)

async function onPageChange() {
  if ($grid.options.loadAll !== false) {
    applyClientPagination($grid)
    await nextTick()
    await $grid.scrollToTop?.()
    return
  }
  void $grid.queryByExamplePage()
}
</script>
